import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { BodyText } from '../../../ui';
import { CheckMarkIcon } from '../../../ui/Icons';
import { SnackbarState } from '../../SnackbarContext';

type DisplaySnackbarArgs = {
  open: (payload: Partial<SnackbarState>) => void;
  close: (payload?: { transition?: string }) => void;
};

// Close review submission snackbar after some time
const REVIEW_CONFIRMATION_TIMEOUT = 7000;

export const displayReviewSubmittedSnackbar = ({ open, close }: DisplaySnackbarArgs) => {
  // Props passed to openSnackbar
  const snackbarProps = {
    sideColor: BrandColor.Green,
    sideContent: (
      <Box
        justifyContent="center"
        alignItems="center"
        paddingTop={12}
        paddingLeft={4}
        minWidth={45}
      >
        <CheckMarkIcon height={32} width={32} color={BrandColor.Green} />
      </Box>
    ),
    mainContent: (
      <Inline
        flex={1}
        alignItems="center"
        justifyContent="center"
        paddingTop={16}
      >
        <BodyText theme="provider" weight="thin">
          <BodyText theme="provider" weight="bold">Review submitted!</BodyText>
          {' '}
          Now, book your next appointment.
        </BodyText>
      </Inline>
    ),
  };
  let timerId; // Placeholder that will be assigned the timerId to cleanup
  const done = () => {
    clearTimeout(timerId);
    close();
  };

  open(snackbarProps); // Launch snackbar
  timerId = setTimeout(() => done(), REVIEW_CONFIRMATION_TIMEOUT); // Close after a few seconds
};
